var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSimcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.1,
    height: 66.469,
    viewBox: "0 0 42.1 66.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e3264e;stroke:#acacac;stroke-width:0.1px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.05 0.05)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.809,1.385l7.8,7.684V63.086a1.761,1.761,0,0,1-1.573,1.9H2.956a1.761,1.761,0,0,1-1.573-1.9V3.283a1.761,1.761,0,0,1,1.573-1.9H32.809M7.745,62.027H34.252a3.04,3.04,0,0,0,3.038-3.036V32.484a3.04,3.04,0,0,0-3.038-3.039H7.745a3.04,3.04,0,0,0-3.037,3.039V58.991a3.04,3.04,0,0,0,3.037,3.036M33.375,0H2.958A3.134,3.134,0,0,0,0,3.283v59.8a3.134,3.134,0,0,0,2.958,3.283H39.042A3.136,3.136,0,0,0,42,63.086V8.489ZM7.745,60.642a1.652,1.652,0,0,1-1.653-1.651V32.484a1.652,1.652,0,0,1,1.653-1.654H34.252A1.652,1.652,0,0,1,35.9,32.484V58.991a1.652,1.652,0,0,1-1.653,1.651Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.175,
    height: 11.267,
    rx: 0.587,
    transform: "translate(15.336 30.207)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.175,
    height: 11.267,
    rx: 0.587,
    transform: "translate(26.122 30.207)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.175,
    height: 11.267,
    rx: 0.587,
    transform: "translate(15.585 49.962)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.175,
    height: 11.267,
    rx: 0.587,
    transform: "translate(26.44 49.962)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.769,3.8a.587.587,0,0,0-.383-.733A46.868,46.868,0,0,0,.764.026.6.6,0,0,0,.317.065.587.587,0,0,0,.41,1.145a43.849,43.849,0,0,1,9.622,3.046A.674.674,0,0,0,10.769,3.8Z",
    transform: "translate(26.266 40.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0",
    transform: "translate(37.316 46.676)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.77.389a.587.587,0,0,1-.383.733A46.92,46.92,0,0,1,.764,4.171a.6.6,0,0,1-.448-.038A.587.587,0,0,1,.41,3.052,43.88,43.88,0,0,0,10.036.006.665.665,0,0,1,10.77.389Z",
    transform: "translate(26.52 46.876)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.028.389a.586.586,0,0,0,.382.737,46.923,46.923,0,0,0,9.622,3.046.6.6,0,0,0,.448-.039.586.586,0,0,0-.09-1.08A44.12,44.12,0,0,1,5.459,1.8,43.907,43.907,0,0,1,.767.005.669.669,0,0,0,.028.389Z",
    transform: "translate(5.884 46.908)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.44.888a1.073,1.073,0,0,1,0-.115A1.835,1.835,0,0,0,6.37.432.781.781,0,0,0,6.339.35,1.2,1.2,0,0,0,6.027.082.614.614,0,0,1,5.918,0c-.259.082-.52.156-.784.24A46.921,46.921,0,0,0,.409,2.02a.587.587,0,0,0-.382.733.666.666,0,0,0,.733.383A43.86,43.86,0,0,1,5.452,1.344c.31-.1.615-.191.918-.279C6.395,1.008,6.418.948,6.44.888Z",
    transform: "translate(5.566 41.383)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,1.339a.586.586,0,0,0,.587.586,17.749,17.749,0,0,1,11.027,0,.6.6,0,0,0,.415-.172.587.587,0,0,0-.415-1A20.588,20.588,0,0,0,.587.752.667.667,0,0,0,0,1.339Z",
    transform: "translate(15.585 49.21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,.587A.587.587,0,0,1,.587,0,17.747,17.747,0,0,0,11.614,0a.6.6,0,0,1,.415.172.587.587,0,0,1-.415,1,20.588,20.588,0,0,1-11.027,0A.665.665,0,0,1,0,.587Z",
    transform: "translate(15.336 40.237)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimcard);
export default __webpack_public_path__ + "static/media/simcard.5a285d90abf60fcb8ba1dbed8d592252.svg";
export { ForwardRef as ReactComponent };